import { Address, makeAddressRecordSync, ProtocolKey } from "@silo/types";
import { satisfies } from "effect/Function";

export const MARKET_ADDRESS = satisfies<
  Record<ProtocolKey, Record<string, Address>>
>()({
  mainnetLegacy: makeAddressRecordSync({
    WBTC: "0x31f3b3b86a074e2ffc4fd75d8eb9721a75ee04dc",
    FXS: "0xf39f64d85ad89200e3b06c67f679c45798bf6a5b",
    APE: "0xd953cc57d906e1f2d7d6c8c50a369ff64096ddc5",
    CVX: "0xa104f14aeeb9b7246367d6a6e1f4e2c61a70e5d3",
    wstETH: "0x4f5717f1efdec78a960f08871903b394e7ea95ed",
    FRAX: "0x67cdb77c6c641f9881cdce6a9e223411fefd507c",
    USDC: "0xfccc27aabd0ab7a0b2ad2b7760037b1eab61616b",
    BAL: "0x92e7e77163ffed918421e3cb6e0a22f2fe8b37fa",
    cbETH: "0x2eaf84b425822edf450fc5fdeec085f2e5ada98b",
    CRV: "0xaa7103f98e57c63e1bc7a9479c8c025adff9f71d",
    sETH2: "0x76f7e7b28aee365ad89a780a911a373ad168e4fc",
    XAI: "0xc8cd77d4cd9511f2822f24ad14fe9e3c97c57836",
    LINK: "0xcb3b879ab11f825885d5add8bf3672596d35197c",
    BADGER: "0x2a03006671eb5e6e669ba207214c5a5d1cbbf7d6",
    AURA: "0x67b2d089c39c59a49f8fbdea43f5878b3a3f65c3",
    SUSHI: "0xf6a891ed8a2e3eaf7fe82f393e092ff1c3218cbc",
    USDT: "0xcd888c9bd53c1ca49b9251f74cc93c73e22963fa",
    ENJ: "0xfcd6c806113a63b7e41a36dfb7455cf368fe8493",
    PAXG: "0xfc51cdc5fb693b9e762cdc5fbee3e2f5f3a09aed",
    MIM: "0xf6354c2855828aedcf0b76d3da33151ddab96d22",
    OHM: "0xf5ffabab8f9a6f4f6de1f0dd6e0820f68657d7db",
    WOO: "0xf0ac1e0a40cb37df3e2f1a753fdcd60276beb5cf",
    ZRX: "0xeab9f43eec7e9743a21209c21f61ad9875891649",
    SHIB: "0xe82a8cf3709f7432f60e9c67f8754bec29a0fd7d",
    GUSD: "0xdfc9fa42859c9c194ee4fb1d7795bbf87d4f5e42",
    USDP: "0xdaf53dec1949aa50f13c7c270941e82f3d633bd3",
    CRO: "0xd7fa3b1fab8df421628a62044e732e3e98ed0e66",
    COMP: "0xd4405e0005677448c2b9474a8bc49972b0691407",
    MANA: "0xcb357b59f0711373fe077df1255ecd253ad7d49f",
    gOHM: "0xc413dd03555f3eb29d834b482d386b2999dc2eb0",
    GNO: "0xbd0ebb9c19db07446425c3cab642e46d27aff115",
    LUSD: "0xbc6594df90ddeada7cdd70dbc08e221a77512deb",
    ENS: "0xbc0dbe249c548fe984ce152a2886f0c3685e3ed7",
    IMX: "0xbb3a395cfebac2c2540ddcd0496bf7fed3cb1eda",
    BUSD: "0xb4a345cc6b2d1bd78e6ac5dfebbcbe339499b2f6",
    ONEINCH: "0xaeafe7ba306ca37cb7c69f6a2822541a28c116e8",
    QNT: "0xac3333401e69574d433307b31f43a7826eb6f8fd",
    TUSD: "0xa24b79de6b567661b42cf6831c8fb9f73f72ebfc",
    YFI: "0xa0460fceb47886920aad8a87b627f3890793d1a6",
    BAT: "0x974a8aabb956c66847772c8f6174d83d37044c32",
    UMA: "0x9175bae4dbcbb45609e13b69370f6c7664366add",
    sUSD: "0x89446dda5d592fdea707a4d6134f4cae213ed79d",
    JPEG: "0x862cc3f126f82d6d3832f707bb75a8783f9e9583",
    BNT: "0x7f7e0652a0b319ef576189c66c8a491a0475a4e0",
    LDO: "0x7e0809d61674df02fd807ae7970055f66c55059d",
    USDD: "0x78ebd52383a7bbfb7ed42f5a16f33c2ac1c014c5",
    SETHTWO: "0x76f7e7b28aee365ad89a780a911a373ad168e4fc",
    NFTX: "0x75ab467a262e02326a513dc532998b6b69ddb5fe",
    DAI: "0x71d11118f64536a1722e86e3d0815556169ceca8",
    BIT: "0x6f2ae3c41b690523e38c9c2f73e5e0b2c5b63931",
    XSUSHI: "0x6de106804eb821255ef995fab4150bc110e8a00c",
    SPELL: "0x6dbae4ca94d24b74e680a781b549124d864693fa",
    FARM: "0x6543ee07cf5dd7ad17aeecf22ba75860ef3bbaaa",
    RPL: "0x63e5d6cc84ed2a6336b2a06fb5b4318f70f14b45",
    LQTY: "0x629b9e70a7d32c718318d691dda5da585e468b82",
    OCEAN: "0x5ea5eaf7086e7203385e6a39b57451d4e9fe9521",
    ALCX: "0x5d510bda7a8301f424c02d83e8b1ac1515ac3908",
    DYDX: "0x58f93cb4ef4e3428066c848ec4d054edd68441af",
    SAND: "0x4a19e9e306cc200af0f27b3f360c242000f4e08b",
    SNX: "0x4872428c93bc52450c435223bece8b4a622b4252",
    UNI: "0x465aaace8fa54bef7f6c8c33774f42213b4c5986",
    AAVE: "0x41170a87e64290c2ba2e8e2bdd41ecf1bf2cb151",
    RAI: "0x3f59a2441f2d2f3fcbad00fb71552d0129c32482",
    KP3R: "0x3089fe36fb298b57961c0e6d889e834bd1d7639f",
    FUN: "0x2cdf83e90924f19d431c79de138bb60d66b82d4f",
    MATIC: "0x27e3bcd1d4fc51c4f060b31153d1134a67e02643",
    FTT: "0x1f1a8c0928c5b395e3a36b1f849352ac4b115b41",
    PERP: "0x10baec25928983d1eff60e24658adf10d42fdb1d",
    wNXM: "0x0d2a3bc9d5b144b34ac4f4bb5c0192be25f7e19d",
    MKR: "0x0bce613ef6a197e8c56be525cf173c27b49ac47d",
    LOOKS: "0x00c64ae39df498b8e77355d2085b8f968f0e3954",
    agEUR: "0x87b2c460acbeb86d4c1abd5104fe27dbbea215ba",
    rETH: "0xb1590d554dc7d66f710369983b46a5905ad34c8c",
    PEPE: "0x7A0e248e1Ae9A042e5fBC7daBDbbdF1bF738B07f",
    XDEFI: "0x6926E507339eca2b01BeDe825d762F4EA19E13C2",
    BOX_ETH: "0xe7F63C75aBc21E43c7bd83aA338BFb58FF7A7178",
    ETH_stETH: "0x03ff864f65a69e6c025f68f5695fa243f8d2d61b",
    FRAX_USDC: "0x0a898eba24e6d1213f1e494d49e757640628aeec",
    ETH_cbETH: "0xb7a9776a65c0abcea036c4f37c889ca44d9cd698",
    LUSD_3CRV: "0x74a633b156b55711d0c91e64fa7de3b7af87470a",
    stETH_NG: "0x339666A930fd79C190e824dd9d9df0393b8BD196",
    weETH: "0xCD7ae3373F7e76A817238261b8303FA17D2AF585",
    ETHx: "0x9080775f499Ef84FEd22a5A2bc13b1B2D2728687",
    PTezETH: "0x03E543365cb2C762c31D5BE4555E871d17155Ac7",
    ezETH: "0xB5077F7561400b01106D151718099B22c4616FBF",
    PTrswETH: "0xd6fAb6ea3694979eEc12701C4Bf86D78ca4835A1",
    rsETH: "0x9318a4aF26Ad2A2D2c5783BBc90Bd809f72a47df",
    PTrsETH: "0x84AC0C7cA24b4a3912701A2e55F8013aDF37C2F1",
    PTweETH: "0xb7413babdEe30d4b496a499c28211498956e82d8",
    PTezETH_DEC2024: "0xC47429cba84F8128559958c970Df5BC6CA2B9c89",
  }),
  mainnetLlama: makeAddressRecordSync({
    rETH: "0x463c0b5e3f52ab27ffe02c23e803903e5e5b361f",
    LQTY: "0x076AD078cE2b22F208dED6812e4D5de4a3Ee4088",
    LINK: "0x2c2A3aBBa45BF2D52CeB0Eb3A55A4E354F986901",
    OHM: "0x3876cA746cC3b25f304F8da8f9F80C220C99D750",
    SNX: "0x5128fb075c5F770bfC53152aBB37A62BB9dBf723",
    JPEG: "0x750dFbDeba85077F7Cb17d6Bf412BF620ED4bB51",
    YFI: "0xb0823c25cDF531a58e581eE14f160c290fef5722",
    LDO: "0xB2dc362990B405845DaF147e357AaD75E6EBD803",
    RPL: "0xc9ae642D3A2792c429219bA641C4a2a8fB8f7dC5",
    CBETH: "0xF60535Db51E4639e0d23E4A3C2bA60194BF0f426",
    UNI: "0x4F11D892fd89CF16651fc1A2526CcfbddED3E616",
    USDC: "0xA56D5162a4E3Bc6Ed6395b05765e18EdAa3ceDFe",
    CRV: "0x96eFdF95Cc47fe90e8f63D2f5Ef9FB8B180dAeB9",
    UWU: "0xDc4c07CDCb0fc4A6D6446c789f9B734e22A7391a",
    sUSDe: "0x6cE02337e26164aF01D049A1E7FE9215De9DF31D",
  }),
  mainnetGrand: makeAddressRecordSync({
    PT_ezETH_26SEP2024: "0xf2443e687Ec149B9b1571AB5017e242017B42fCb",
    PT_weETH_26SEP2024: "0xE6c6Bb43D1cA6bcf2320D4c472Ad51aA747C15b1",
    PT_sUSDE_26SEP2024: "0xaE64A1a45C1d2A85e01449d85010Ab1671eeC7eF",
    PT_pufETH_26SEP2024: "0x3cD47F09D176d7a0998E23D41caF6bC516d519B6",
    ezETH: "0x36B41888BD223dFB4a7ce2eeA75E3D82fB866A9e",
    weETH: "0x26a334F76A1aC40Bb6094131f7D30BBA0c08D4c6",
    pzETH: "0x1cdbde50F9D122CCE8fe8D08d0D482b0161fFD15",
    amphrETH: "0x992298cb9a6aafaDBc038dC85f1a1C012F45b67d",
    rstETH: "0xb3499737F35973a73A6270ae6616eca3E2dC0f65",
    re7LRT: "0x884725A8dd9E8591E851C88Eb665735f8D86da8C",
    PT_weETH_DEC2024: "0xa2AED60DbDd09c91C2e686E948592dc1c1Cd0cc6",
    PT_rsETH_DEC2024: "0xF94f40873e662086666bdA3eC58801AC35B2921a",
    PT_pufETH_DEC20204: "0xD48043A0f99501A057CE1De4C09d982BB433aBAC",
  }),
  arbitrum: makeAddressRecordSync({
    GMD: "0xf60b7c2d1fb0ba86fe20baf86d04df738acfe577",
    USDs: "0xe7e8f9f1aa6eaaead05dc32d50c7db93c0ec82e1",
    DAI: "0xe60bb5f4795c829f0a917b2f847e21a748d0e36c",
    GMX: "0xde998e5eef06dd09ff467086610b175f179a66a0",
    CRV: "0xd713ef310351055af26c6d3e20c4e629090c39a5",
    UMAMI: "0xc0ab69fffeb5375235d8caa4f7218097bbcc0a0a",
    LINK: "0x8efe27352025aa1d04a6a5f9c4a624ad60f4702b",
    DPX: "0x7e38a9d2c99caef533e5d692ed8a2ce4b478e585",
    WBTC: "0x69ec552be56e6505703f0c861c40039e5702037a",
    MAGIC: "0x30c4aa967f68705ab5677ebe17b3affd0c59e71c",
    USDT: "0x2ae0c6d43102c1f4413abe3001e0554622211351",
    CAP: "0x0a386825e513ebe07e25d6570d21a932276c2327",
    UNI: "0x033f86120c101b0480b5c70327a8e90c4ae35041",
    GNS: "0xfc6778a6955e1cecac448051de967f9b5ff4d647",
    rDPX: "0x950aaeda8c6e806a8c889b4dbcc0361760b86249",
    ARB: "0x0696e6808ee11a5750733a3d821f9bb847e584fb",
    PREMIA: "0x5eda4bee7ba556e65bc4fb9eed5d74e61bc1f2a9",
    JONES: "0x82622a6bdD2f1FA757a08837633971D42C17241a",
    OHM: "0x862Da0A25E3DFE46df2CD4c14D79E1E4684dEa4a",
    WSTETH: "0xA8897b4552c075e884BDB8e7b704eB10DB29BF0D",
    SILO: "0xae1Eb69e880670Ca47C50C9CE712eC2B48FaC3b6",
    rETH: "0x170A90981843461295a6CE0e0a631eE440222E29",
    Y2K: "0xA0CF37273068b461dF43f1cfb58E2B2CEcB56706",
    JOE: "0x8922225135acBAC6f49AaCCC638A8fB79119795C",
    PLS: "0xa4487d52a5AC147f249D44D5AF8b3C71Eba77478",
    GRAIL: "0xB9D098E61eC165D3c530Dd67CE77B18BE426ea91",
    PENDLE: "0xEa9961280b48fe521ece83f6cD8a7E9B2C4ffc2e",
    RDNT: "0x19d3F8D09773065867e9fD11716229e73481c55A",
    WOO: "0x5C2B80214c1961dB06f69DD4128BcfFc6423d44F",
    WINR: "0x6036bEb05ff71215d1257fC1Db1586c87746464F",
    stEUR: "0xE5741B993dBee7B433c1cfd0c885BAB901DD406d",
    LUSD: "0xaee935408b94bae1Ce4eA15d22b3cA33c91eFe81",
    weETH: "0x7bec832FF8060cD396645Ccd51E9E9B0E5d8c6e4",
    PTeETH: "0x7Cc5267E706794f4E0562b70f288A4b7C1bE0457",
    tBTC: "0xf3FC3812360390f95dd4A57C6BC36498fB44d518",
    GRAI: "0x4B80a3b80471759beA54f9432eE36B50fe4F945B",
    PTezETH: "0x64689F922af39f186bA1465A19aD191Db91AC8D5",
    ezETH: "0x4a2bd8dcc2539e19cb97DF98EF5afC4d069d9e4C",
    PTweETH: "0xd49929d4ab1845bC0CFe19dBe94B6f40c48591f0",
    PTrsETH: "0xA109e2Bc1fCEC084A5be20237b755fb4747d87E3",
    WOETH: "0x9f4D6f98F29c1D482bCF0F85683155E0B3e015f5",
    PTUSDe: "0xd5B8df98Fd76932422F6c00434d07468Ae2eBC93",
    PTezETH_SEPT2024: "0x6aEed300592d615BAE0aa73A4119741BCb40a4D8",
    PTweETH_SEPT2024: "0xaf2Dd9e15084481116782309d4FdCa11f3344015",
    PTrsETH_SEPT2024: "0x255BB86BD29e10095982F74AE141c103a49a6e72",
    uniETH: "0x601B76d37a2e06E971d3D63Cf16f41A44E306013",
    ETHplus: "0x1182559e5cf2247e4DdB7a38e28a88ec3825f2BA",
    PEAS: "0xc49b9CB9CCe1448e2E5ceF86b844980d74CeFC64",
    RAM: "0x07501B81285a8c136C04C8Cb5f39300317BB44c4",
    wUSDplus: "0xA1cada48eB6bE2247e35b3a0F152C255D015F256",
    gUSDC: "0xb15d831103e69a1D48F1ec4670bB9B9fAAa1F6fC",
    ptUSDE_NOV2024: "0x1e2968B3e23D625906F32A94dbFe2F44930c6Db7",
    dlcBTC: "0x2cC4E8c0654EaB7eD84D861859230B0aC5e1C511",
    wUSDM: "0x334B2aCfc56433Bdb3Bd8BB0D66e37e5615109Ae",
    PTweETH_DEC2024: "0x1E5B48F3130502FFD1DFb6d24AC3C42269e41538",
    PTrsETH_DEC2024: "0x00b7BBDd582Ef58445aA87Ac6Beb61F5fA36e71b",
    ORDER: "0x5196C0A390D6507246a5E7B8db8f197C51694861",
    PTweETH_JUN2025: "0x1324D3765d08763A0399ae6C2EaAbfC1D98E557b",
    PTrsETH_JUN2025: "0x29892E34791f55654Cc7F1c40697D1c54CF21634",
    gmETH: "0x2a4bC099c743553890f62fd74Ca0cb05e23334ff",
    TANGO: "0xEa00305557FEa9bA1cfd699ebD38336ecd0F487c",
  }),
  optimism: makeAddressRecordSync({
    SNX: "0xE5056228706F295E0F38774B263b4E56e0770fd5",
    PENDLE: "0xDe8291d3D9Fe34Ce8386621F8ac66101c7601A97",
    VELO: "0xB369B1748b8d970F77213D71b474b2Fd6F9A6c1E",
    DAI: "0xa1194bE146bBe8a404D01c4F0068AeBE8223d2E2",
    rETH: "0xa0Cf0085F3DF7d44EAa7AB7EFF41D7867210dB62",
    OP: "0x8ED1609D796345661d36291B411992e85DE7B224",
    sUSD: "0x6E74F45ce5ab06594aE799e8E8e012866a294A8F",
    WLD: "0x689228d22c896CC85FA267B2FAe3BC46e91Cbf4b",
    tBTC: "0x5f1e2a5952446F0E231C839Dace4fEfbFc478614",
    PERP: "0x5a68c626C4E2c698AD89e1165d3242D97176Ab6f",
    USDT: "0x463D952045CbcfFcFcD7653b47A8810D5DF5D215",
    sfrxETH: "0x2Dc1292B9b26dBEb6d2b59E708f9356027F4E3Cc",
    wstETH: "0x1eBF59146ccdc4650044fc70CAfac298A6083F5f",
    WBTC: "0x03d0b417b7Bcd0C399f1db3321985353a515B2b8",
    ezETH: "0x12ee4BE944b993C81b6840e088bA1dCc57F07B1D",
    uniBTC: "0xd9b605F0b9e64328ae50d1b44EC14d38c009a702",
    wUSDM: "0xa6FF502259e5cC2e5bD6ce02EA2AcbFee13858B6",
    mooBIFI: "0x26Dd60f1B3B6c784e1e2bd767D1F31ABFEb2f04E",
  }),
  base: makeAddressRecordSync({
    cbETH: "0x839Aa8B0641b77db2C9eFFEC724DD2dF46290FA2",
    wstETH: "0xEB42de7d17dfAFfD03AF48c2A51c3FB7274d3396",
    DEGEN: "0xd56E1B712885D516e5918B099e0FdE439cDAA10c",
    ezETH: "0xd54A83D47934D889364Dd5Af2d6855Dcf05745C3",
    AERO: "0xcaC9d4DF6c98dA614639f71400145f163B5F77c5",
    bsdETH: "0xBa37De7624944487791E2F11Bf16d2E7f2644Ad6",
    weETH: "0x8095806d8753C0443C118D1C5e5eEC472e30BFeC",
    tBTC: "0x2e790440334F564fE14b57Ba35DdF0f024e163f2",
    cbBTC: "0xDa79416990e7FA79E310Ab938B01ED75CBB64a90",
    wUSDM: "0x32321d83Eba04CC267854f9CfcD8FD59D362731a",
    wUSDPlus: "0xb82a644a112AD609B89C684Ce2B73757f00D9C3D",
    sUSDz: "0x459B353dA108851eA3779C5399F3148a45E1Bb90",
    EURC: "0x9E166d324C4177B176C3E5b274853C6ae9Aa1466",
    wSuperOETHb: "0x190e5C6AabB2BeC4eB0B9b2274e9b62cdaEDF356",
    hyUSD: "0x63617EF707843cde49ccb2dec7ad62B8e7976F5C",
    pumpBTC: "0xB3697B0C275145499bD4b1542ed3C44061907C13",
  }),
  lrtbase: makeAddressRecordSync({
    tBTC: "0x1aCDf09477Bd1BB36e2c2042d8313daCC09c0C1a",
    solvBTC: "0xE103fbA6B23755DC3b7f9Ff7923B995F87eB7700",
    solvBTCBNN: "0x1A1FCCE03b2dC77A3A2AEA95C4AC9610313176bB",
    LBTC: "0x08A9C1F51598dfA8161433B4F24ed9210BB9bC8A",
    PT_LBTC: "0x71aA073A736757D55d5e2a47b517263845a9B567",
  }),
  local: makeAddressRecordSync({
    WBTC: "0x266B82aB8C9a46B0D79De216Fb13e48b2Ee87a86",
    CRV: "0x2d387653bA1aca235680A21fDc5a32b4c3A79d09",
  }),
  anvil: makeAddressRecordSync({
    ETH_stETH: "0x7A0e248e1Ae9A042e5fBC7daBDbbdF1bF738B07f",
    FRAX_USDC: "0xe7F63C75aBc21E43c7bd83aA338BFb58FF7A7178",
    ETH_cbETH: "0xCD7ae3373F7e76A817238261b8303FA17D2AF585",
    LUSD_3CRV: "0x9080775f499Ef84FEd22a5A2bc13b1B2D2728687",
    USDC: "0xfccc27aabd0ab7a0b2ad2b7760037b1eab61616b",
  }),
} as const);
